import { createContext } from 'react';

const FeedContext = createContext();

export { FeedContext };
